export function initMenu() {
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  let openMenu = false;

  // Globální funkce pro inline onclick handlery
  window.openCloseNav = function() {
    if (vw > 768) return;

    const menu = document.getElementById("main-menu");
    menu.style.display = openMenu ? "none" : "flex";
    openMenu = !openMenu;
  };
}
